import { enumToJson } from "@bufbuild/protobuf";
import { ExternalDestinationType, ExternalDestinationTypeSchema, type ExternalDestinationJson } from "#gen/bundles/v1/bundle_pb.js";

export const DEFAULT_URL = "https://www.example.com";
const DEFAULT_EMAIL_URL = "mailto:test@example.com?subject=Contact%20me&body=I'm%20interested!";
const DEFAULT_SMS_URL = "sms:+18005550123;?&body=Im%20interested!";
const DEFAULT_PHONE_URL = "tel:+18005550123";

export const DEFAULT_URL_CONFIG: ExternalDestinationJson = {
	type: enumToJson(ExternalDestinationTypeSchema, ExternalDestinationType.URL),
	url: DEFAULT_URL,
};
export const DEFAULT_EMAIL_CONFIG: ExternalDestinationJson = {
	type: enumToJson(ExternalDestinationTypeSchema, ExternalDestinationType.EMAIL),
	url: DEFAULT_EMAIL_URL,
};
export const DEFAULT_SMS_CONFIG: ExternalDestinationJson = {
	type: enumToJson(ExternalDestinationTypeSchema, ExternalDestinationType.SMS),
	url: DEFAULT_SMS_URL,
};
export const DEFAULT_PHONE_CONFIG: ExternalDestinationJson = {
	type: enumToJson(ExternalDestinationTypeSchema, ExternalDestinationType.PHONE),
	url: DEFAULT_PHONE_URL,
};
export const DEFAULT_DEEPLINK_CONFIG: ExternalDestinationJson = {
	type: enumToJson(ExternalDestinationTypeSchema, ExternalDestinationType.DEEPLINK),
	url: "",
};
